import { render, staticRenderFns } from "./assetDepreciationDialog.vue?vue&type=template&id=8b2bf978&scoped=true"
import script from "./assetDepreciationDialog.vue?vue&type=script&lang=js"
export * from "./assetDepreciationDialog.vue?vue&type=script&lang=js"
import style0 from "./assetDepreciationDialog.vue?vue&type=style&index=0&id=8b2bf978&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2bf978",
  null
  
)

export default component.exports